export const FETCH_LEADERBOARD = "FETCH_LEADERBOARD";
export const FETCH_LEADERBOARD_FULFILLED = "FETCH_LEADERBOARD_FULFILLED";
export const FETCH_LEADERBOARD_REJECTED = "FETCH_LEADERBOARD_REJECTED";

export const FETCH_RANKING = "FETCH_RANKING";
export const FETCH_RANKING_FULFILLED = "FETCH_RANKING_FULFILLED";
export const FETCH_RANKING_REJECTED = "FETCH_RANKING_REJECTED";
